import React, { useState } from 'react';
import { Box, Button, Paper, Table, TableBody, TableCell, TableContainer, TableHead, TablePagination, TableRow, TextField, Typography } from '@mui/material';
import { useUsersAdminTable } from '../hooks/useUsersAdminTable';

export default function AdminUsersTable() {
  const {
    rows, filterId, setFilterId, filterNombre, setFilterNombre, filterProfesional, setFilterProfesional, sortDate, setSortDate, toggleUserActive,
  } = useUsersAdminTable();
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const [selectedRow, setSelectedRow] = useState(null);

  return (
    <>
      <Box display="flex" justifyContent="space-between" alignItems="center">
        <Typography variant="h6" component="h2" gutterBottom color="#0D6AEE">Lista de Usuarios</Typography>
        <Button variant="contained" disabled={!selectedRow} onClick={() => selectedRow && toggleUserActive(selectedRow)}>
          {selectedRow && selectedRow.active ? 'Dar de Baja' : 'Activar'}
        </Button>
      </Box>
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={2}>
        <TextField name="id" label="Filtrar por ID" value={filterId} onChange={(e) => setFilterId(e.target.value)} style={{ marginRight: 16 }} />
        <TextField name="nombre" label="Filtrar por Nombre" value={filterNombre} onChange={(e) => setFilterNombre(e.target.value)} style={{ marginRight: 16 }} />
        <TextField name="profesional" label="Filtrar por Profesional" value={filterProfesional} onChange={(e) => setFilterProfesional(e.target.value)} style={{ marginRight: 16 }} />
        <Button variant="contained" onClick={() => setSortDate(sortDate === 'asc' ? 'desc' : 'asc')} style={{ marginRight: 16 }}>
          Ordenar por fecha {sortDate === 'asc' ? '⬆️' : '⬇️'}
        </Button>
        <Button variant="contained" onClick={() => { setFilterId(''); setFilterNombre(''); setFilterProfesional(''); setSortDate(null); }}>
          Resetear Filtros
        </Button>
      </Box>
      <Paper sx={{ width: '100%', overflow: 'hidden' }}>
        <TableContainer sx={{ maxHeight: 300 }}>
          <Table stickyHeader>
            <TableHead>
              <TableRow>
                <TableCell>id</TableCell>
                <TableCell>nombre</TableCell>
                <TableCell>tipo de profesional</TableCell>
                <TableCell align="right">fecha de creación</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {rows.length === 0 ? (
                <TableRow><TableCell colSpan={4} align="center">No hay usuarios registrados</TableCell></TableRow>
              ) : rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => (
                <TableRow key={row.id} hover onClick={() => setSelectedRow(row)} sx={{ cursor: 'pointer', backgroundColor: row.active ? 'white' : 'lightgrey' }}>
                  <TableCell>{row.id}</TableCell>
                  <TableCell>{row.nombre}</TableCell>
                  <TableCell>{row.profesional}</TableCell>
                  <TableCell align="right">{new Date(row.createdAt).toLocaleDateString()}</TableCell>
                </TableRow>
              ))}
            </TableBody>
          </Table>
        </TableContainer>
        <TablePagination rowsPerPageOptions={[5, 10, 20]} component="div" count={rows.length} rowsPerPage={rowsPerPage} page={page} onPageChange={(_e, newPage) => setPage(newPage)} onRowsPerPageChange={(e) => { setRowsPerPage(+e.target.value); setPage(0); }} />
      </Paper>
    </>
  );
}
